import API from 'apiCalls/api'
import { objectToQueryString } from 'variables/functions'

export async function getBookings(token, queryObj = { limit: 50 }) {
  const queryString = objectToQueryString(queryObj)

  let response

  try {
    response = await API.get(`booking/?${queryString}`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function toggleCancelBookings(body, booking_id, package_id, token) {
  let response
  try {
    response = await API.patch(`booking/${booking_id}/?package_id=${package_id}`, body, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

// export async function getActiveBookings(token) {
//   let response
//   try {
//     response = await API.get(`booking/?archived=False`, {
//       headers: { Authorization: `token ${token}` },
//     })
//   } catch (error) {
//     response = error.response
//   }
//   return response
// }

// export async function getArchivedBookings(token) {
//   let response
//   try {
//     response = await API.get(`booking/?archived=True`, {
//       headers: { Authorization: `token ${token}` },
//     })
//   } catch (error) {
//     response = error.response
//   }
//   return response
// }

export async function getNextBookings(token, URL) {
  let response
  try {
    response = await API.get(`${URL}`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function createBooking(token, source, body, packIdentifier) {
  let response
  try {
    response = await API.post('booking/', body, {
      headers: { Authorization: `token ${token}` },
      cancelToken: source.token,
      params: { packageId: packIdentifier },
    })
  } catch (error) {
    if (error.message) {
      response = error.response
    } else {
      response = error
    }
  }
  return response
}

export async function createBookingPublic(source, body, packIdentifier) {
  let response
  try {
    response = await API.post('booking-public/', body, {
      cancelToken: source.token,
      params: { packageId: packIdentifier },
    })
  } catch (error) {
    if (error.message) {
      response = error.response
    } else {
      response = error
    }
  }
  return response
}

export async function updateBooking(UID, token, source, body, packIdentifier) {
  let response
  try {
    response = await API.patch(`booking/${UID}/?package_id=${packIdentifier}`, body, {
      headers: { Authorization: `token ${token}` },
      cancelToken: source.token,
      params: { packageId: packIdentifier },
    })
  } catch (error) {
    if (error.message) {
      response = error.response
    } else {
      response = error
    }
  }
  return response
}

export async function getPublicBooking(identifier, source) {
  let response
  try {
    response = await API.get(`booking-public/${identifier}/`, {
      cancelToken: source.token,
    })
  } catch (error) {
    if (error.message) {
      response = error.response
    } else {
      response = error
    }
  }
  return response
}

// For Booking Requests

export async function createBookingRequest(body, source) {
  let response
  try {
    response = await API.post(`booking_request-public/`, body, {
      cancelToken: source.token,
    })
  } catch (error) {
    if (error.message) {
      response = error.response
    } else {
      response = error
    }
  }
  return response
}

export async function getBookingRequests(token, queryObj = { limit: 50 }) {
  const queryString = objectToQueryString(queryObj)

  let response

  try {
    response = await API.get(`booking_request/?${queryString}`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function getBookingRequest(identifier, token) {
  let response
  try {
    response = await API.get(`booking_request/${identifier}/`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    if (error.message) {
      response = error.response
    } else {
      response = error
    }
  }
  return response
}

export async function updateBookingRequest(identifier, token, source, body) {
  let response
  try {
    response = await API.patch(`booking_request/${identifier}/`, body, {
      headers: { Authorization: `token ${token}` },
      cancelToken: source.token,
    })
  } catch (error) {
    if (error.message) {
      response = error.response
    } else {
      response = error
    }
  }
  return response
}

export async function createScheduledEmail(token, source, body, bookingId) {
  let response

  try {
    response = await API.post('future_email/', body, {
      headers: { Authorization: `token ${token}` },
      cancelToken: source.token,
      params: { bookingId: bookingId },
    })
  } catch (error) {
    if (error.message) {
      response = error.response
    } else {
      response = error
    }
  }
  return response
}

export async function updateScheduledEmail(token, source, body, identifier) {
  let response
  try {
    response = await API.patch(`future_email/${identifier}/`, body, {
      headers: { Authorization: `token ${token}` },
      cancelToken: source.token,
    })
  } catch (error) {
    if (error.message) {
      response = error.response
    } else {
      response = error
    }
  }
  return response
}

export async function deleteScheduledEmail(token, source, identifier) {
  let response
  try {
    response = await API.delete(`future_email/${identifier}/`, {
      headers: { Authorization: `token ${token}` },
      cancelToken: source.token,
    })
  } catch (error) {
    if (error.message) {
      response = error.response
    } else {
      response = error
    }
  }
  return response
}

///---- Function to download bookings as CSV file ----///
export async function downloadBookingsCSV(token, path, photographerId, startDate, endDate) {
  let fileName = path === 'bookings-csv' ? 'bookings.csv' : 'payments.csv'
  try {
    // Initialize the params object
    let params = {
      start_date: startDate,
      end_date: endDate,
    }

    // Remove undefined or null parameters
    Object.keys(params).forEach((key) => {
      if (!params[key]) {
        delete params[key]
      }
    })

    const response = await API.get(`/photographers/${photographerId}/${path}/`, {
      headers: {
        Accept: 'text/csv', // Specify that the server response should be in CSV format.
        Authorization: `token ${token}`, // Authentication header to ensure the request is authorized.
      },
      params: params, // Pass the parameters
      responseType: 'blob', // Set response type to blob to handle binary data, suitable for downloads.
    })

    if (response.status === 200) {
      const blob = new Blob([response.data], { type: 'text/csv' })
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    } else {
      throw new Error(`Failed to download file: Status ${response.status}`)
    }
  } catch (error) {
    console.error('Error downloading the file:', error)
    return { error: true, message: error.message }
  }
}
